import { render, staticRenderFns } from "./OrigenBase.vue?vue&type=template&id=240cc1da"
import script from "./OrigenBase.vue?vue&type=script&lang=js"
export * from "./OrigenBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports